import BackgroundQuestion from "./BackgroundQuestion";
export default BackgroundQuestion;
